import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    track,
    isClient
} from '../helpers';

import {
    renderNextRoutesOnClient
} from '../redux/modules/routing/actions';

import HelpPage from '../components/help/HelpPage';

import {
    TRACK_DATA,
} from '../config/constants';

import {
    saveTrackingData
} from '../redux/modules/tracking/actions';

import { loadTrackData } from './common/routingHelpers';

import { injectConfig } from '@client/hoc/config';

class Help extends React.Component {

    render() {
        return (
            isClient() && <HelpPage
                location={this.props.location}
            />
        );
    }

    componentDidMount() {
        loadTrackData(this.props.config).then(data => {
            this.props.saveTrackingDataAction(data);
            track(TRACK_DATA, data);
        });
        this.props.renderNextRoutesOnClientAction();
    }
}

Help.propTypes = {
    renderNextRoutesOnClientAction: PropTypes.func,
    saveTrackingDataAction: PropTypes.func,
    location: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
};

const mapStateToProps = (/* state */) => ({});

const mapDispatchToProps = (dispatch) => ({
    renderNextRoutesOnClientAction: () => renderNextRoutesOnClient(),
    saveTrackingDataAction: (data) => saveTrackingData(data)(dispatch)
});

export default compose(injectConfig, connect(mapStateToProps, mapDispatchToProps))(Help);
